import Vue from 'vue'
/* eslint-disable vue/no-dupe-keys */
// import the component
import Treeselect from '@riophae/vue-treeselect'
import dataTools from '../../tools/data'
import Plotly from 'plotly.js-dist'
import * as Cesium from 'cesium'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import dataDescription from '../../tools/dataDescription.json'

export default () => {
  Vue.component('treeselect', Treeselect)

  Vue.component('exo-npq-finder', {
    props: {
      root: Object,
      useSunSynchronousInclination: {
        type: Boolean,
        default: false
      },
      useWalkerInclination: {
        type: Boolean,
        default: false
      },
      npqBuilderWatcher: Array,
      isEllipticalType: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        npqPlotDrawDom: 'drawNPQPlot',
        errorNPQBuilder: ''
      }
    },

    methods: {
      createRequestForNPQBuilder() {
        let npqBuilderRequest = {}
        if (this.useSunSynchronousInclination) {
          npqBuilderRequest.inclinationType = 'SSO'
        } else {
          npqBuilderRequest.inclinationType = 'INCLINATION'
          console.log(this.root.inputs.constellationType)
          if (this.useWalkerInclination) {
            console.log('walker')
            npqBuilderRequest.inclination = dataTools.convertGui2si(
              this.root.getFieldType('walkerI'),
              this.root.inputs.walkerI
            )
          } else {
            console.log('custom')
            npqBuilderRequest.inclination = dataTools.convertGui2si(
              this.root.getFieldType('inclination'),
              this.root.inputs.inclination
            )
          }
        }
        if (this.root.inputs.type === 'Circular') {
          npqBuilderRequest.eccentricityType = 'CIRCULAR'
          npqBuilderRequest.minAltitude = dataTools.convertGui2si(
            this.root.getFieldType('minAltitude'),
            this.root.inputs.minAltitude
          )
          npqBuilderRequest.maxAltitude = dataTools.convertGui2si(
            this.root.getFieldType('maxAltitude'),
            this.root.inputs.maxAltitude
          )
        } else if (this.root.inputs.type === 'Elliptical') {
          npqBuilderRequest.eccentricity = this.root.inputs.eccentricity
          npqBuilderRequest.eccentricityType = 'ELLIPTIC'
          npqBuilderRequest.minSma = dataTools.convertGui2si(
            this.root.getFieldType('minSMA'),
            this.root.inputs.minSMA
          )
          npqBuilderRequest.maxSma = dataTools.convertGui2si(
            this.root.getFieldType('maxSMA'),
            this.root.inputs.maxSMA
          )
        } else {
          npqBuilderRequest.eccentricity = 0
          npqBuilderRequest.eccentricityType = 'CIRCULAR'
          npqBuilderRequest.minAltitude = dataTools.convertGui2si(
            this.root.getFieldType('minAltitude'),
            this.root.inputs.minAltitude
          )
          npqBuilderRequest.maxAltitude = dataTools.convertGui2si(
            this.root.getFieldType('maxAltitude'),
            this.root.inputs.maxAltitude
          )
        }
        npqBuilderRequest.minQ = this.root.inputs.minQ
        npqBuilderRequest.maxQ = this.root.inputs.maxQ
        console.log(npqBuilderRequest)
        return npqBuilderRequest
      },

      getPlotTitle() {
        let title = 'Repeat orbit'
        if (this.isEllipticalType) {
          title +=
            ' - Eccentricity: ' +
            dataTools.displayTypeDigits(
              'coefficient',
              this.root.inputs.eccentricity
            )
        } else {
          title += ' - Circular'
        }
        if (this.useSunSynchronousInclination) {
          title += ' - Sun-synchronous'
        } else {
          if (this.useWalkerInclination) {
            title +=
              ' - Inclination: ' +
              dataTools.displayTypeDigits('angle', this.root.inputs.walkerI) +
              ' deg'
          } else {
            title +=
              ' - Inclination: ' +
              dataTools.displayTypeDigits(
                'angle',
                this.root.inputs.inclination
              ) +
              ' deg'
          }
        }
        return title
      },

      buildNPQText(npqEphemeris) {
        let text = []
        npqEphemeris.xValues.forEach((value, index) => {
          text[index] =
            `${this.isEllipticalType ? 'SMA' : 'Altitude'}: ` +
            `${npqEphemeris.xValues[index]} km <br>` +
            `N: ${npqEphemeris.nValues[index]}<br>` +
            `P: ${npqEphemeris.pValues[index]}<br>` +
            `Q: ${npqEphemeris.qValues[index]}`
        })
        return text
      },

      drawNPQPlot(npqEphemeris) {
        let self = this
        let myPlot = document.getElementById(this.npqPlotDrawDom)
        npqEphemeris.xValues = []
        const xLabel = this.isEllipticalType ? 'Semi-major axis' : 'Altitude'
        const values = this.isEllipticalType
          ? npqEphemeris.smaValues
          : npqEphemeris.altitudeValues
        values.forEach((altitude, index) => {
          npqEphemeris.xValues[index] = dataTools.convertSi2Display(
            'distance',
            altitude
          )
        })
        let npqText = this.buildNPQText(npqEphemeris)
        let layout = {
          title: {
            text: this.getPlotTitle(),
            font: {
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            }
          },
          width: 600,
          margin: {
            r: 40,
            l: 40,
            t: 40,
            b: 100
          },
          plot_bgcolor: 'rgba(0,0,0,0)',
          paper_bgcolor: 'rgba(0,0,0,0)',
          xaxis: {
            title: {
              text: xLabel + ' (km)',
              font: {
                color: this.$vuetify.theme.dark ? 'white' : '#121212'
              }
            },
            tickfont: {
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            },
            zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212'
          },
          yaxis: {
            title: {
              text: 'Q',
              font: {
                color: this.$vuetify.theme.dark ? 'white' : '#121212'
              }
            },
            tickfont: {
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            },
            zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212'
          }
        }
        let trace = {
          x: npqEphemeris.xValues,
          y: npqEphemeris.qValues,
          n: npqEphemeris.nValues,
          marker: {
            size: 7
          },
          text: npqText,
          hoverinfo: 'text',
          mode: 'markers'
        }
        let data = [trace]
        Plotly.newPlot(this.npqPlotDrawDom, data, layout)
        myPlot.on('plotly_click', function (npq) {
          self.root.inputs.n = npqEphemeris.nValues[npq.points[0].pointIndex]
          self.root.inputs.p = npqEphemeris.pValues[npq.points[0].pointIndex]
          self.root.inputs.q = npqEphemeris.qValues[npq.points[0].pointIndex]
        })
      },

      async getNPQMarkers() {
        this.errorNPQBuilder = ''
        try {
          Plotly.purge(this.npqPlotDrawDom)
        } catch (error) {}

        if (this.root.displayNPQPlot) {
          await this.root.$http
            .post('/physics/npqbuilder', this.createRequestForNPQBuilder())
            .then((response) => {
              this.drawNPQPlot(response.data)
            })
            .catch((e) => {
              if (e.response) {
                this.errorNPQBuilder = this.friendlifyParseError(
                  e.response.data
                )
              } else {
                console.log(e)
              }
            })
        }
      },

      friendlifyParseError(error) {
        // method partly duplicated from logHandler.js
        let message = error.message == null ? error : error.message

        if (message.includes('JSON parse error:')) {
          let middleError = message.split('JSON parse error: ')[1]
          middleError = middleError.split('; nested exception is')[0]

          return 'Bad request (' + middleError + ')'
        } else {
          return message
        }
      }
    },

    watch: {
      npqBuilderWatcher() {
        setTimeout(() => {
          this.getNPQMarkers()
        }, 200)
      }
    },
    template: `
      <div>
        <v-row>
          <v-col cols="4" offset-md-1>
            <exo-input-double :root="root" name="minQ"/>
          </v-col>
          <v-col cols="4" offset-md-1>
            <exo-input-double :root="root" name="maxQ"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" offset-md-1>
          <exo-input-double :root="root" :name="isEllipticalType ? 'minSMA' : 'minAltitude'"/>
          </v-col>
          <v-col cols="4" offset-md-1>
            <exo-input-double :root="root" :name="isEllipticalType ? 'maxSMA' : 'maxAltitude'"/>
          </v-col>
        </v-row>
        <exo-form-alert typBe="info">
            {{this.errorNPQBuilder}}
        </exo-form-alert>
        <v-row>
          <div :id="this.npqPlotDrawDom"></div>
        </v-row>
      </div>`
  })

  Vue.component('exo-display-orbit-traces', {
    props: {
      tracesResults: Object,
      root: Object, // TODO : Test that all windows using orbit traces are working once root removed
      text: String,
      pointOfInterest: {
        type: Object,
        default: null
      },
      parentObject: {
        type: Object,
        default: null
      },
      id: String // id required to not use same drawing area for 2 different components
    },

    watch: {
      tracesResults: function (value) {
        setTimeout(() => {
          this.drawVisualizationResult(value)
        }, 200)
      }
    },

    data() {
      return {
        drawingDomName: 'visualizationDraw' + this.id
      }
    },

    beforeDestroy() {
      // delete
      try {
        Plotly.purge(this.drawingDomName)
      } catch (e) {}
    },

    methods: {
      addPlaneTraces(data, tracesCoordinate) {
        for (let geometryIndex in tracesCoordinate.traces) {
          let geometryTraces = tracesCoordinate.traces[geometryIndex]
          let dataTMP = []
          for (let planeIndex in geometryTraces) {
            let planeTraceSpherical = {
              text: [],
              type: 'scattermapbox',
              mode: 'markers',
              lat: [],
              lon: [],
              showlegend: false,
              hoverinfo: 'text',
              marker: {
                reversescale: false
              }
            }
            for (let pointIndex in geometryTraces[planeIndex]) {
              let cartesianResult = new Cesium.Cartesian3()
              let sphericalResult = new Cesium.Spherical()
              Cesium.Cartesian3.fromArray(
                geometryTraces[planeIndex][pointIndex],
                0,
                cartesianResult
              )
              Cesium.Spherical.fromCartesian3(cartesianResult, sphericalResult)
              let lon = dataTools.rad2deg(sphericalResult.clock)
              planeTraceSpherical.lon[pointIndex] = lon
              // warning the cone is the angle from +z to -z, see the cesium documentation
              planeTraceSpherical.lat[pointIndex] =
                dataTools.setAngleDegAround0(
                  90 - dataTools.rad2deg(sphericalResult.cone)
                )
              planeTraceSpherical.text[
                pointIndex
              ] = `Longitude: ${dataTools.formatAngle(
                lon
              )}<br>Latitude: ${dataTools.formatAngle(
                planeTraceSpherical.lat[pointIndex]
              )}`
            }
            dataTMP.push(planeTraceSpherical)
          }
          this.addSpacecraftVue(dataTMP, tracesCoordinate, geometryIndex)
          dataTMP.forEach((elt) => data.push(elt))
        }
      },

      squareOrientation(latlon, spacecraftVue) {
        let deltaLat = Math.log(
          Math.tan((latlon.lat[1] * Math.PI) / 180 / 2 + Math.PI / 4) /
            Math.tan((latlon.lat[0] * Math.PI) / 180 / 2 + Math.PI / 4)
        )
        let deltaLon = Math.abs(
          (((latlon.lon[0] * Math.PI) / 180) % 180) -
            (((latlon.lon[1] * Math.PI) / 180) % 180)
        )
        let orientation
        // equivalent to testing if inclination > | < 90 deg
        if (latlon.lon[0] > latlon.lon[1]) {
          orientation = Math.atan2(deltaLon, deltaLat)
        } else {
          orientation = -Math.atan2(deltaLon, deltaLat)
        }
        for (let index in spacecraftVue.lon) {
          let lon =
            Math.cos(orientation) * (spacecraftVue.lon[index] - latlon.lon[0]) -
            Math.sin(orientation) * (spacecraftVue.lat[index] - latlon.lat[0]) +
            latlon.lon[0]
          let lat =
            Math.sin(orientation) * (spacecraftVue.lon[index] - latlon.lon[0]) +
            Math.cos(orientation) * (spacecraftVue.lat[index] - latlon.lat[0]) +
            latlon.lat[0]

          spacecraftVue.lat[index] = lat
          spacecraftVue.lon[index] = lon
        }
      },

      getSquareLatitudeCoordinate(latlon, lat) {
        let coordinate = []
        coordinate.push(latlon.lat[0] - lat * 0.5)
        coordinate.push(latlon.lat[0] - lat * 0.5)
        coordinate.push(latlon.lat[0] + lat * 0.5)
        coordinate.push(latlon.lat[0] + lat * 0.5)
        coordinate.push(coordinate[0])
        return coordinate
      },

      getSquareLongitudeCoordinate(latlon, lon) {
        let coordinate = []
        coordinate.push(latlon.lon[0] - lon * 0.5)
        coordinate.push(latlon.lon[0] + lon * 0.5)
        coordinate.push(latlon.lon[0] + lon * 0.5)
        coordinate.push(latlon.lon[0] - lon * 0.5)
        coordinate.push(coordinate[0])
        return coordinate
      },

      addSpacecraftVue(dataGeometry, tracesCoordinate, geometryIndex) {
        if (tracesCoordinate.payloads) {
          let payload = tracesCoordinate.payloads[geometryIndex]
          if (payload?.centerAngleAlongTrackOperatingAltitude != null) {
            let dataTmp = []
            let ratio = 0.001
            dataGeometry.forEach((latlon) => {
              let index = 0
              let spacecraftVue = {
                type: 'scattermapbox',
                mode: 'lines',
                hoverinfo: 'none',
                lat: [],
                lon: [],
                showlegend: false,
                marker: {
                  reversescale: false
                }
              }
              if (payload.fieldOfViewType === 'TYPE_CIRCULAR') {
                while (index !== 2000) {
                  spacecraftVue.lat[index] =
                    latlon.lat[0] +
                    Math.sin(ratio * Math.PI) *
                      dataTools.rad2deg(
                        payload.centerAngleAlongTrackOperatingAltitude
                      )
                  spacecraftVue.lon[index] =
                    latlon.lon[0] +
                    Math.cos(ratio * Math.PI) *
                      dataTools.rad2deg(
                        payload.centerAngleAlongTrackOperatingAltitude
                      )
                  ratio = ratio + 0.001
                  index++
                }
                spacecraftVue.lat[index] = spacecraftVue.lat[0]
                spacecraftVue.lon[index] = spacecraftVue.lon[0]
              } else if (payload.fieldOfViewType === 'TYPE_RECTANGULAR') {
                let lonSwath =
                  payload.swathCrossTrackOperatingAltitude *
                  (360 / (2 * Math.PI * 6378136.3))
                let latSwath =
                  payload.swathAlongTrackOperatingAltitude *
                  (360 / (2 * Math.PI * 6378136.3))
                spacecraftVue.lon = this.getSquareLongitudeCoordinate(
                  latlon,
                  lonSwath
                )
                spacecraftVue.lat = this.getSquareLatitudeCoordinate(
                  latlon,
                  latSwath
                )
                this.squareOrientation(latlon, spacecraftVue)
              }
              dataTmp.push(spacecraftVue)
            })
            dataTmp.forEach((spacecraftVue) => {
              dataGeometry.push(spacecraftVue)
            })
          }
        }
      },

      getSquareCoordinateWithMinMax(lonMin, lonMax, latMin, latMax) {
        let lonLat = {
          lat: [],
          lon: []
        }
        lonLat.lat[0] = latMin
        lonLat.lon[0] = lonMin
        lonLat.lat[1] = latMax
        lonLat.lon[1] = lonMin
        lonLat.lat[2] = latMax
        lonLat.lon[2] = lonMax
        lonLat.lat[3] = latMin
        lonLat.lon[3] = lonMax
        lonLat.lat[4] = latMin
        lonLat.lon[4] = lonMin
        return lonLat
      },

      addPointOfInterestArea(data) {
        for (const area of this.pointOfInterest.areasOfInterest) {
          let pointOfInterestArea = {
            type: 'scattermapbox',
            mode: 'lines',
            hoverinfo: 'none',
            lat: [],
            lon: [],
            showlegend: false,
            marker: {
              reversescale: false
            }
          }
          let latMin = dataTools.rad2deg(area.minLatitude)
          let lonMin = dataTools.rad2deg(area.minLongitude)
          let latMax = dataTools.rad2deg(area.maxLatitude)
          let lonMax = dataTools.rad2deg(area.maxLongitude)
          let lonLat = this.getSquareCoordinateWithMinMax(
            lonMin,
            lonMax,
            latMin,
            latMax
          )
          pointOfInterestArea.lat = lonLat.lat
          pointOfInterestArea.lon = lonLat.lon
          data.push(pointOfInterestArea)
        }
      },

      addIsolatedPointsOfInterest(data) {
        let isolatedPointsOfInterest = {
          text: [],
          type: 'scattermapbox',
          mode: 'markers',
          hoverinfo: 'text',
          lat: [],
          lon: [],
          showlegend: false,
          marker: {
            reversescale: false,
            size: 10
          }
        }
        for (let isolatePointIndex in this.pointOfInterest
          .isolatedPointsOfInterest) {
          isolatedPointsOfInterest.lat.push(
            dataTools.rad2deg(
              this.pointOfInterest.isolatedPointsOfInterest[isolatePointIndex]
                .latitude
            )
          )
          isolatedPointsOfInterest.lon.push(
            dataTools.rad2deg(
              this.pointOfInterest.isolatedPointsOfInterest[isolatePointIndex]
                .longitude
            )
          )
          isolatedPointsOfInterest.text.push(
            `Point of interest :<br>Longitude: ${dataTools.formatAngle(
              dataTools.rad2deg(
                this.pointOfInterest.isolatedPointsOfInterest[isolatePointIndex]
                  .longitude
              )
            )}` +
              `<br>Latitude: ${dataTools.formatAngle(
                dataTools.rad2deg(
                  this.pointOfInterest.isolatedPointsOfInterest[
                    isolatePointIndex
                  ].latitude
                )
              )}`
          )
        }
        data.push(isolatedPointsOfInterest)
      },

      drawVisualizationResult(tracesCoordinate) {
        try {
          Plotly.purge(this.drawingDomName)
        } catch (e) {}
        if (tracesCoordinate != null) {
          let data = []
          this.addPlaneTraces(data, tracesCoordinate)
          // this.addSpacecraftVue(data, tracesCoordinate)
          if (this.pointOfInterest != null) {
            this.addPointOfInterestArea(data)
            this.addIsolatedPointsOfInterest(data)
          }
          let layout = {
            autosize: true,
            mapbox: {
              style: this.$vuetify.theme.dark ? 'dark' : 'light',
              zoom: 0
            },
            margin: {
              r: 0,
              l: 0,
              t: 0,
              b: 0,
              pad: 0
            },
            showlegend: false
          }
          Plotly.setPlotConfig({
            mapboxAccessToken:
              'pk.eyJ1IjoiZXhvdHJhaWwiLCJhIjoiY2szcTNnZmFkMDkzbzNtcDhzMm0ydmJ5YyJ9.5so1MY_ou6yoPmLAzLchUg'
          })
          Plotly.react(this.drawingDomName, data, layout, { responsive: true })
        }
      }
    },

    template: `
    <div>          
      <v-row no-gutters align-center>
        <v-col class="ml-3">
          <exo-input-date-time name="visualizationDate" :root="root" :parentObject="this.parentObject" :forceDisplay="true" forcedLabel="Date to visualize the ground tracks" v-if="!(id == 'analyticalOrbit')">
          <exo-help-dialog margin="mt-3" title="Reference date">
          Allows to take Sun position into account. This is also the reference date for the constellation initial RAAN/MLTAN.
        </exo-help-dialog>
        </exo-input-date-time>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <exo-form-alert type="info">
            {{this.text}}
          </exo-form-alert>
        </v-col>
      </v-row>
      <v-row>
      <v-col>
      <slot></slot>
      </v-col>
      </v-row>
      <v-row align-end>
        <v-col>
          <div :id="drawingDomName" ref="geo"></div>
        </v-col>
      </v-row>
    </div>`
  })

  Vue.component('exo-select-field', {
    props: ['field', 'root'],

    template: `
    <v-select    :items="root.axisOptions"
                  label="Text"
                  v-on:input="root.pathUpdated(field)"
                  v-model="field.path"
                  :menu-props="{transition:'scale-transition'}">
    </v-select>
    `
  })

  Vue.component('exo-select-unit', {
    props: ['field', 'root'],

    template: `
    <v-select
                v-if="field.unitOptions.length > 1"
                :items="field.unitOptions"
                label="Unit"
                v-on:input="root.unitUpdated(field)"
                v-model="field.unit"
                :menu-props="{transition:'scale-transition'}">
    </v-select>
    `
  })

  Vue.component('exo-multi-axis-options', {
    props: ['root'],

    template: `
      <v-row>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" v-on:click="root.addNewAxis" class="grey--text darken-4 m-0">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Add Axis</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :disabled="root.configuration.multiAxis.length <=   1" v-on:click="root.removeLastAxis" class="grey--text darken-4 m-0">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>Remove last axis</span>
        </v-tooltip>
      </v-row>
      `
  })

  Vue.component('exo-target-config', {
    props: ['root'],

    data() {
      return {
        dialog: false
      }
    },

    template: `
      <v-dialog width="750" v-model="dialog">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">
             <v-icon class="pr-2">settings</v-icon>
            Targets
          </v-btn>
        </template>
        <v-card>
          <v-container class="pt-0">
            <v-card-title :class="{'justify-center': root.configuration.targets.length === 0}">
              <span class="headline">Targets Configuration</span>
            <v-spacer></v-spacer>
            <v-btn icon small class="m-0" @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            </v-card-title>
            <v-divider class="mt-0 mb-3"></v-divider>
            <v-card-text class="p-2">
              <v-row class="justify-center text-center" v-if="root.configuration.targets.length === 0">
                <v-col>
                  <p class="subheading">You still have not set any target for this plot</p>
                  <p class="body-1">Click on the button below to add a target</p>
                  <p class="body-1">Warning: on multiaxis, the targets are displayed on the first axis configuration</p>
                </v-col>
              </v-row>
              <exo-target-row v-for="(target, index) in root.configuration.targets" :key="target.id"
                                :target="target" :index="index" :root="root"/>
            </v-card-text>
            <v-card-actions :class="{'justify-center': root.configuration.targets.length === 0}">
              <v-btn color="primary" dark v-on:click="root.addNewTarget">
                <v-icon class="pr-2" :class="{'d-none': root.configuration.targets.length === 0}" dark>add</v-icon> 
                Add target
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    `
  })

  Vue.component('exo-target-row', {
    props: ['target', 'index', 'root'],

    methods: {
      treeselectClass() {
        if (this.$vuetify.theme.dark === true) {
          return 'treeselect-dark'
        }
        return ''
      }
    },

    template: `
      <v-row>
        <v-col cols="6" class="pr-3">
          <treeselect
            :options="root.filteredTreeOptions"
            :disable-branch-nodes="true"
            :show-count="true"
            v-model="target.treevalue"
            v-on:input="root.pathTargetUpdated(target)"
            :class="treeselectClass() + ' pt-3'"
            placeholder="Select target field"
            :maxHeight="95"
            >
            <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
          </treeselect>
        </v-col>
        <v-col cols="2" class="pr-2">
          <v-select     
            :items="root.targetTypes"
            v-model="target.type">
          </v-select>
        </v-col>
        <v-col cols="3" class="pr-2">
          <v-select
              v-bind:items="root.getPlotlyColors()"
              v-bind:style="{ color: target.color }"
              v-model="target.color">

            <template slot="selection" slot-scope="data">
              <div :style="{ color: data.item }">
                {{ data.item }}
              </div>
            </template>
            <template slot="item" slot-scope="data">
              <div grow v-bind:style="{ color: data.item }">
                {{ data.item }}
              </div>
            </template>
          </v-select>
        </v-col>
        <v-col cols="1" class="pt-2">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="grey--text darken-4"  v-on:click="root.removeTarget(index)">
                <v-icon size="29">delete</v-icon>
              </v-btn>
            </template>
            <span>Remove Target</span>
          </v-tooltip>
        </v-col>
      </v-row>
    `
  })

  Vue.component('exo-path-select-row', {
    props: {
      root: Object,
      fieldName: String,
      field: Object,
      disableTree: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      menu: false
    }),

    methods: {
      getUnit() {
        if (typeof this.field.unit === 'object' || this.field.unit === '') {
          return ''
        }
        return ' (' + this.field.unit + ')'
      },
      treeselectClass() {
        if (this.$vuetify.theme.dark) {
          return 'treeselect-dark'
        }
        return ''
      }
    },

    template: `
      <v-row no-gutters class="pt-2">
        <v-col cols="11">
          <v-menu
              v-model="menu"  
              :disabled="!menu"
              :close-on-content-click="false"
              transition="slide-y-transition"
              class="w-100"
              offset-y
            >
              <template v-slot:activator="{ on }">
              <treeselect
                :class="treeselectClass()"
                v-on="on"
                v-on:click="menu = false"
                :options="root.filteredTreeOptions"
                :disable-branch-nodes="true"
                :disabled="disableTree"
                :show-count="true"
                v-model="field.value"
                v-on:input="root.treeUpdated(field,fieldName)"
                :placeholder="'Select ' + fieldName + ' field'"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel + getUnit()}}</div>
              </treeselect>
              </template>
              <v-card>
                <v-card-text>
                  <v-text-field
                    horizontal
                    label="Label"
                    v-model="field.label"
                    maxlength="50"
                  >
                  </v-text-field>
                  <exo-select-unit :field="field" :root="root"/>
                </v-card-text>
              </v-card>
          </v-menu>
        </v-col>
        <v-col cols="1">
          <v-btn icon class="grey--text darken-4 ma-0" :disabled="field.value == null"  v-on:click="menu = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    `
  })

  Vue.component('exo-filters-config', {
    props: ['root'],

    data() {
      return {
        dialog: false
      }
    },

    template: `
        <v-dialog width="1000" persistent v-model="dialog">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">
              <v-icon class="pr-2" dark>settings</v-icon>
              Filters
            </v-btn>
          </template>
          <v-card>
            <v-col class="pt-0">
              <v-card-title :class="{'justify-center': root.configuration.filters.length === 0}">
                <span class="headline">Filters Configuration</span>
              </v-card-title>
              <v-divider class="mt-0 mb-3"></v-divider>
              <v-card-text class="p-2">
                <v-col v-if ="root.filteredResults.length === 0 && root.configuration.filters.length > 0" cols="12">
                  <v-alert outlined type="warning" :value="true">Filters combination hides all results</v-alert>
                </v-col>
                <v-col v-if ="root.filteredResults.length > 0 && root.configuration.filters.length > 0" cols="12">
                  <v-alert outlined type="success" :value="true">Filtered results: {{ root.filteredResults.length }} / {{ root.plotData.length }}</v-alert>
                </v-col>
                <v-row class="justify-center text-center" v-if="root.configuration.filters.length === 0">
                  <v-col>
                    <p class="subheading">You still have not set any filter for this plot</p>
                    <p class="body-1">Click on the button below to add a filter</p>
                  </v-col>
                </v-row>
                <exo-filter-row v-for="(filter, index) in root.configuration.filters" :key="filter.id"
                                    :filter="filter" :index="index" :root="root"/>
              </v-card-text>
              <v-card-actions :class="{'justify-center': root.configuration.filters.length === 0}">
                <v-btn color="primary" outlined dark v-on:click="root.addFilter">
                  <v-icon class="pr-2" :class="{'d-none': root.configuration.filters.length === 0}" dark>add</v-icon> 
                  Add Filter
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark  @click="dialog = false">
                  Apply
                </v-btn>

              </v-card-actions>
            </v-col>
          </v-card>
        </v-dialog>
      `
  })

  Vue.component('exo-filter-row', {
    props: ['filter', 'index', 'root'],

    data: () => ({
      menu: false,
      displayFilter: true,
      minMaxValueError: '',
      context: 'ParametricStudyResult'
    }),

    methods: {
      treeselectClass() {
        if (this.$vuetify.theme.dark) {
          return 'treeselect-dark'
        }
        return ''
      },
      sortNumbers(list) {
        return list.sort((a, b) => parseFloat(a) - parseFloat(b))
      },
      getItemConverted(filter, item) {
        let itemConverted = dataTools.convertFromSi(
          dataTools.getFieldTypeFromPath(
            filter.path,
            this.context,
            this.root.currentResultsLog.scriptConfig
          ),
          item,
          filter.unit
        )
        if (typeof itemConverted === 'number') {
          return itemConverted.toFixed(dataTools.getNbToDisplay(filter.unit))
        }
        return itemConverted
      },
      getUnit() {
        if (typeof this.filter.unit === 'object' || this.filter.unit === '') {
          return ''
        }
        return ' (' + this.filter.unit + ')'
      },
      clearFilter() {
        this.filter.path = []
        this.filter.unit = null
        this.filter.unitOptions = []
        this.filter.valueOptions = []
        return true
      },
      isNumber(filter) {
        const type = dataTools.getFieldTypeFromPath(
          filter.path,
          this.context,
          this.root.currentResultsLog.scriptConfig
        )
        if (type != null && type !== '') {
          const basicType = dataDescription[type].type
          return (
            basicType === 'double' ||
            basicType === 'int' ||
            basicType === 'integer'
          )
        }
        return false
      },
      filterBetweenMinMax() {
        this.minMaxValueError = ''
        if (
          (!this.filter.min && this.filter.min !== 0) ||
          (!this.filter.max && this.filter.max !== 0)
        ) {
          return
        }
        if (this.filter.min > this.filter.max) {
          this.minMaxValueError = 'Minimum > Maximum'
          return
        }
        this.filter.value = []
        if (this.filter) {
          for (const value of this.filter.valueOptions) {
            if (value <= this.filter.max && value >= this.filter.min) {
              this.filter.value.push(value)
            }
          }
        }
        this.root.applyFilters()
      }
    },

    template: `
        <v-row no-gutters>
          <v-col cols="5" class="pt-3">
            <v-menu
              v-model="menu"  
              :disabled="!menu"
              :close-on-content-click="false"
              transition="slide-y-transition"
              class="w-100"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <treeselect
                  :class="treeselectClass()"
                  v-on="on"
                  v-on:click="menu = false"
                  :options="root.treeOptions"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  v-model="filter.treevalue"
                  v-on:input="root.pathFilterUpdated(filter)"
                  placeholder="Select field"
                  openDirection="top"
                  :maxHeight="168"
                  :beforeClearAll="clearFilter"
                  >
                    <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel + getUnit()}}</div>
                  </treeselect>
              </template>
              <v-card>
                <v-card-text>
                  <v-select
                    v-if="root.isChoice(filter.unitOptions)"
                    :items="filter.unitOptions"
                    label="Unit"
                    v-model="filter.unit"
                    :menu-props="{transition:'scale-transition'}"
                  ></v-select>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-row>
              <exo-form-alert type="error">
                {{minMaxValueError}}
              </exo-form-alert>
            </v-row>
          </v-col>
          <v-col class="pr-1">
            <v-btn icon class="grey--text darken-4 mt-3" v-if="root.isChoice(filter.unitOptions)" v-on:click="menu = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" class="pr-4">
            <v-select
              multiple
              v-if="!isNumber(filter)"
              v-on:input="root.applyFilters()"
              :items="root.listFilterOptions(filter)"
              label="Values"
              v-model="filter.value"
              :menu-props="{transition:'scale-transition'}"
            >
              <template v-slot:item="{ item, attrs }">
                  <v-checkbox v-model="attrs.inputValue"/>
                  <span>{{ item }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filter.value.length - 1 }} others)</span>
              </template>
              <template v-slot:selection="{ item }">
                {{ typeof (item) === 'number' ? getItemConverted(filter, item) : item}}
              </template>
            </v-select>
            <v-row no-gutters v-if="isNumber(filter)">
              <v-col cols="5">
                <v-select
                  v-on:input="filterBetweenMinMax()"
                  :items="sortNumbers(root.listFilterOptions(filter))"
                  label="Minimum"
                  v-model="filter.min"
                  :menu-props="{transition:'scale-transition'}"
                >
                  <template v-slot:item="{ item }">
                    {{ getItemConverted(filter, item)}}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ getItemConverted(filter, item) }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="5" class="ml-2">
                <v-select
                  v-on:input="filterBetweenMinMax()"
                  :items="sortNumbers(root.listFilterOptions(filter))"
                  label="Maximum"
                  v-model="filter.max"
                  :menu-props="{transition:'scale-transition'}"
                >
                  <template v-slot:item="{ item }">
                    {{ getItemConverted(filter, item) }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ getItemConverted(filter, item) }}
                  </template>
              </v-select>
              </v-col>
            </v-row>
          </v-col> 
          <v-col class="mr-2 mt-3">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon class="grey--text darken-4" v-on:click="root.removeFilter(index)">
                  <v-icon size="29">delete</v-icon>
                </v-btn>
              </template>
              <span>Remove Filter</span>
            </v-tooltip>
          </v-col>
        </v-row>
    `
  })

  Vue.component('exo-parameter-row', {
    props: ['parameter', 'index', 'root'],

    data: () => ({
      menu: false
    }),

    methods: {
      getUnit() {
        if (
          typeof this.parameter.unit === 'object' ||
          this.parameter.unit === ''
        ) {
          return ''
        }
        return ' (' + this.parameter.unit + ')'
      },
      treeselectClass() {
        if (this.$vuetify.theme.dark === true) {
          return 'treeselect-dark'
        }
        return ''
      }
    },

    template: `
    <v-row no-gutters>
      <v-col cols="10">
        <v-menu
          v-model="menu"  
          :disabled="!menu"
          :close-on-content-click="false"
          transition="slide-y-transition"
          class="w-100"
          offset-y
        >
          <template v-slot:activator="{ on }">
          <treeselect
              :class="treeselectClass()"
                v-on="on"
              v-on:click="menu = false"
              :options="root.treeOptions"
              :disable-branch-nodes="true"
              :show-count="true"
              v-model="parameter.value"
              v-on:input="root.treeUpdated(parameter,'parameter')"
              placeholder="Select parameter"
              >
              <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel + getUnit()}}</div>
          </treeselect>
          </template>
          <v-card>
            <v-card-text>
              <exo-select-unit :field="parameter" :root="root"/>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="1">
        <v-btn icon class="grey--text darken-4 mt-0" :disabled="parameter.value == null"  v-on:click="menu = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon class="grey--text darken-4 mt-0" v-on:click="root.removeParameter(index)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>Remove</span>
        </v-tooltip>
      </v-col>
      </v-row>
    `
  })
}
